/*eslint no-sequences: "off"*/
/*eslint no-empty-pattern: "off"*/

import { createSlice } from "@reduxjs/toolkit";
import { IThemeContext } from './interfaces';
import { initState } from "./init.state";

export const ThemeContextSlice = createSlice({
  name: "themeContext",
  initialState: initState,
  reducers: {

    SetColors: (state: IThemeContext, action: any) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    SetBackgroundState: (state: IThemeContext, action: any) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    SetMinTimeResolution: (state: IThemeContext, action: any) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    SetBreakPoint: (state: IThemeContext, action: any) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    SetDropDownVisible: (state: IThemeContext, action: any) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    
  
  },
});

// Action creators are generated for each case reducer function
export const {
 SetColors,
 SetBackgroundState,
 SetMinTimeResolution,
 SetBreakPoint,
 SetDropDownVisible,
} = ThemeContextSlice.actions;

export default ThemeContextSlice.reducer;
